import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip } from 'chart.js';
import { fmtDec, fmt, MetricCard, BarList, GC, TC } from '../utils';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

const REP_COLORS_LIST = ['#3ea4b1','#7F77DD','#1D9E75','#D4537E','#EF9F27','#888780','#5DCAA5','#F0997B'];

export default function Overview({ data }) {
  const { owners = [], categories = [], itemsRev = [], itemsQty = [] } = data;
  const sorted = [...owners].sort((a, b) => b.total - a.total);
  const totalRev = sorted.reduce((s, r) => s + r.total, 0);
  const topCat = [...categories].filter(c => c.total > 0).sort((a, b) => b.total - a.total)[0];
  const topItem = itemsRev[0] || [];

  const repBarData = {
    labels: sorted.map(r => r.name.split(' ')[0]),
    datasets: [{ data: sorted.map(r => r.total), backgroundColor: sorted.map((_, i) => REP_COLORS_LIST[i % REP_COLORS_LIST.length]), borderRadius: 5, borderSkipped: false }],
  };
  const repBarOpts = {
    responsive: true, maintainAspectRatio: false,
    plugins: { legend: { display: false }, tooltip: { callbacks: { label: ctx => '$' + Math.round(ctx.parsed.y).toLocaleString() } } },
    scales: { x: { grid: { display: false }, ticks: { color: TC, font: { size: 11 } } }, y: { grid: { color: GC }, ticks: { color: TC, font: { size: 11 }, callback: v => '$' + (v / 1000).toFixed(0) + 'k' } } },
  };

  const topCats = [...categories].filter(c => c.total > 0).sort((a, b) => b.total - a.total).slice(0, 8);
  const catBarData = {
    labels: topCats.map(c => c.name.length > 18 ? c.name.substring(0, 17) + '…' : c.name),
    datasets: [{ data: topCats.map(c => c.total), backgroundColor: '#3ea4b1', borderRadius: 4, borderSkipped: false }],
  };
  const catBarOpts = {
    indexAxis: 'y', responsive: true, maintainAspectRatio: false,
    plugins: { legend: { display: false }, tooltip: { callbacks: { label: ctx => '$' + Math.round(ctx.parsed.x).toLocaleString() } } },
    scales: { x: { grid: { color: GC }, ticks: { color: TC, font: { size: 11 }, callback: v => '$' + (v / 1000).toFixed(0) + 'k' } }, y: { grid: { display: false }, ticks: { color: TC, font: { size: 11 } } } },
  };

  return (
    <div>
      <div className="metrics">
        <MetricCard label="Total revenue" value={fmtDec(totalRev)} sub="2026 YTD" />
        <MetricCard label="Top rep" value={sorted[0]?.name.split(' ')[0] + ' ' + (sorted[0]?.name.split(' ')[1]?.[0] || '') + '.'} sub={fmt(sorted[0]?.total || 0) + ' · ' + Math.round((sorted[0]?.total || 0) / totalRev * 100) + '%'} />
        <MetricCard label="Top category" value={topCat?.name || '—'} sub={topCat ? fmt(topCat.total) : '—'} />
        <MetricCard label="Top item" value={topItem[0] || '—'} sub={topItem[1] ? fmt(topItem[1]) : '—'} />
      </div>

      <div className="charts-grid">
        <div className="chart-card">
          <div className="chart-card-title">Revenue by rep</div>
          <div className="chart-card-sub">All reps, 2026 YTD</div>
          <div className="chart-wrap" style={{ height: 220 }}><Bar data={repBarData} options={repBarOpts} /></div>
        </div>
        <div className="chart-card">
          <div className="chart-card-title">Revenue by category</div>
          <div className="chart-card-sub">Top 8 product categories</div>
          <div className="chart-wrap" style={{ height: 220 }}><Bar data={catBarData} options={catBarOpts} /></div>
        </div>
      </div>

      <div className="two-col">
        <div className="chart-card">
          <div className="chart-card-title">Top items by revenue</div>
          <div className="chart-card-sub">Top 10 item numbers</div>
          <BarList items={itemsRev.slice(0, 10)} maxVal={itemsRev[0]?.[1] || 1} isMoney />
        </div>
        <div className="chart-card">
          <div className="chart-card-title">Top items by quantity</div>
          <div className="chart-card-sub">Top 10 by units sold</div>
          <BarList items={itemsQty.slice(0, 10)} maxVal={itemsQty[0]?.[1] || 1} isMoney={false} />
        </div>
      </div>
    </div>
  );
}
